/* Galerie Vogel — Produkt-Kaufbereich am Bildschirm halten,
   ohne Biografie auszuklappen oder vor Empfehlungen zu geraten. */
(() => {
  "use strict";
  if (window.__gvFollowBuyboxStarted) return;
  window.__gvFollowBuyboxStarted = true;
  const mq = window.matchMedia("(min-width: 1000px)");
  let current = null;
  let frame = 0;
  let observing = null;
  let measuring = null;

  function release(state) {
    if (!state) return;
    state.info.classList.remove("gv-product-info--following");
    state.info.style.removeProperty("--gv-follow-left");
    state.info.style.removeProperty("--gv-follow-top");
    state.info.style.removeProperty("--gv-follow-width");
    state.placeholder.style.height = "0px";
  }

  function bind() {
    const section = document.querySelector(".shopify-section--main-product");
    const product = section && section.querySelector("product-rerender > .product");
    const info = product && product.querySelector(":scope > safe-sticky.product-info");
    if (!section || !product || !info) {
      if (current) release(current);
      current = null;
      return;
    }
    if (current && current.info === info && current.info.isConnected) return;
    if (current) {
      release(current);
      if (current.placeholder.isConnected) current.placeholder.remove();
    }

    const placeholder = document.createElement("div");
    placeholder.className = "gv-product-info__anchor";
    placeholder.setAttribute("aria-hidden", "true");
    product.insertBefore(placeholder, info);

    current = { section, product, info, placeholder, stickyTop: 20 };
    const top = parseFloat(window.getComputedStyle(info).top);
    if (Number.isFinite(top)) current.stickyTop = top;

    if (observing) observing.disconnect();
    if (measuring) measuring.disconnect();
    measuring = new ResizeObserver(schedule);
    measuring.observe(info);
    observing = new MutationObserver(() => {
      if (!current || !current.info.isConnected) bind();
      schedule();
    });
    observing.observe(section, { childList: true, subtree: true });
    schedule();
  }

  function boundaryTop(section) {
    let cutoff = Number.POSITIVE_INFINITY;
    const inside = section.querySelectorAll(".product-content-below-gallery product-recommendations");
    inside.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (!el.hidden && rect.height > 20) cutoff = Math.min(cutoff, rect.top);
    });

    let candidate = section.nextElementSibling;
    while (candidate) {
      const rect = candidate.getBoundingClientRect();
      if (rect.height > 20 && window.getComputedStyle(candidate).display !== "none") {
        cutoff = Math.min(cutoff, rect.top);
        break;
      }
      candidate = candidate.nextElementSibling;
    }
    if (!Number.isFinite(cutoff)) {
      const footer = document.querySelector(".shopify-section-group-footer-group");
      if (footer) cutoff = footer.getBoundingClientRect().top;
    }
    return cutoff;
  }

  function update() {
    frame = 0;
    if (!current || !current.info.isConnected) {
      bind();
      return;
    }

    const s = current;
    if (!mq.matches || document.hidden) {
      release(s);
      return;
    }

    const anchor = s.placeholder.getBoundingClientRect();
    const naturalTop = s.stickyTop;
    const sectionBounds = s.section.getBoundingClientRect();

    // Only follow once the original column has reached the sticky header offset.
    if (anchor.top >= naturalTop || sectionBounds.bottom <= 0) {
      release(s);
      return;
    }

    // Keep the right grid track at its original size when the info is fixed.
    const infoHeight = s.info.getBoundingClientRect().height;
    if (infoHeight <= 0 || anchor.width <= 0) {
      release(s);
      return;
    }
    s.placeholder.style.height = Math.ceil(infoHeight) + "px";
    const endTop = boundaryTop(s.section);
    const lowerMargin = 22;
    const lastVisibleTop = window.innerHeight - infoHeight - lowerMargin;
    const lowestTop = Math.min(naturalTop, lastVisibleTop);
    const passed = Math.max(0, naturalTop - anchor.top);
    const panTop = Math.max(lowestTop, naturalTop - passed * 0.8);
    const desiredTop = Math.min(panTop, endTop - infoHeight - lowerMargin);

    s.info.style.setProperty("--gv-follow-left", anchor.left + "px");
    s.info.style.setProperty("--gv-follow-width", anchor.width + "px");
    s.info.style.setProperty("--gv-follow-top", desiredTop + "px");
    s.info.classList.add("gv-product-info--following");
  }

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }
  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", () => { schedule(); }, { passive: true });
  document.addEventListener("visibilitychange", schedule);
  document.addEventListener("shopify:section:load", () => { bind(); schedule(); });
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind, { once: true });
  else bind();
})();